// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27E4Y","icon":"styles_icon__GmGh_"};